import React from 'react';
import { Select } from 'antd';
import { createReducer } from '../../../../utils/reducerUtil';
import { ACTION_STATUS } from '../../../../utils/ActionStatus';


import {
    // query
    ON_WORK_MANAGEMENT_QUERY_INPUT_CHANGE,
    START_LOAD_CPT_INFO,
    LOAD_CPT_INFO_SUCCESS,
    LOAD_CPT_INFO_FAILURE,
    INIT_LOAD_CPT_INFO_ACTION_STATUS,
    // Select
    SELECT_CPT,
    // add or edit
    OPEN_ADD_OR_EDIT_CPT_MODAL,
    ADD_OR_EDIT_CPT_CHANGE_INPUT,
    RESET_SUBMIT_SAVE_CPT_MODAL,
    START_SUBMIT_SAVE_CPT,
    SUBMIT_SAVE_CPT_SUCCESS,
    SUBMIT_SAVE_CPT_FAILURE,
    INIT_SUBMIT_SAVE_CPT_ACTION_STATUS,


    //SUB add or edit
    OPEN_ADD_OR_EDIT_CPTSUB_MODAL,
    ADD_OR_EDIT_CPTSUB_CHANGE_INPUT,
    RESET_SUBMIT_SAVE_CPTSUB_MODAL,
    START_SUBMIT_SAVE_CPTSUB,
    SUBMIT_SAVE_CPTSUB_SUCCESS,
    SUBMIT_SAVE_CPTSUB_FAILURE,
    INIT_SUBMIT_SAVE_CPTSUB_ACTION_STATUS,



    // batch change status
    OPEN_BATCH_CHANGE_STATUS_MODAL,
    RESET_BATCH_CHANGE_STATUS_MODAL,
    BATCH_CHANGE_STATUS_CHANGE_INPUT,
    START_BATCH_CHANGE_STATUS_FOR_CPT,
    BATCH_CHANGE_STATUS_FOR_CPT_SUCCESS,
    BATCH_CHANGE_STATUS_FOR_CPT_FAILURE,
    INIT_BATCH_CHANGE_STATUS_FOR_CPT_ACTION_STATUS,
    // finish
    SELECT_CPT_TASK,
    OPEN_FINISH_TASK_MODAL,
    RESET_FINISH_TASK_MODAL,
    FINISH_TASK_CHANGE_INPUT,
    START_FINISH_CPT_TASK,
    FINISH_CPT_TASK_SUCCESS,
    FINISH_CPT_TASK_FAILURE,
    INIT_FINISH_CPT_TASK_ACTION_STATUS,

      // Open/Reset Questionnaire Email Edit Modal Dialog
    QUESTIONNAIRE_EMAIL_EDIT_MODAL_DIALOG_OPEN,
    QUESTIONNAIRE_EMAIL_EDIT_MODAL_DIALOG_RESET,


  // Accept Questionnaire Result
  START_ACCEPT_QUESTIONNAIRE_RESULT,
  ACCEPT_QUESTIONNAIRE_RESULT_SUCCESS,
  ACCEPT_QUESTIONNAIRE_RESULT_FAILURE,
  INIT_ACCEPT_QUESTIONNAIRE_RESULT_ACTION_STATUS,

  // Reject Questionnaire Result
  START_REJECT_QUESTIONNAIRE_RESULT,
  REJECT_QUESTIONNAIRE_RESULT_SUCCESS,
  REJECT_QUESTIONNAIRE_RESULT_FAILURE,
  INIT_REJECT_QUESTIONNAIRE_RESULT_ACTION_STATUS,

    // Send Remind Email
    START_SEND_REMIND_EMAIL,
    SEND_REMIND_EMAIL_SUCCESS,
    SEND_REMIND_EMAIL_FAILURE,
    INIT_SEND_REMIND_EMAIL_ACTION_STATUS,

    SET_REGISTER_INFO_BY_NAME,

} from './CptConstants';
import { QUESTIONNAIRE_EMAIL_SEND_MODE } from '../../../../utils/QuestionnaireEmailSendMode';
import {
    // Load User Account
    LOAD_USER_ACCOUNTS_SUCCESS,
  } from '../../../features/home/homeConstants';

  import {
    LOAD_LICENSINGFORM_SUCCESS,
} from '../licensingForm/licensingFormConstants';
import { selectUserRegisterInfoByName } from './CptActions';
const Option = Select.Option;

const departmentOptions = [];
departmentOptions.push(<Option key={'Investment'}>{'Investment'}</Option>);
departmentOptions.push(<Option key={'Trading'}>{'Trading'}</Option>);
departmentOptions.push(<Option key={'Marketing'}>{'Marketing'}</Option>);
departmentOptions.push(<Option key={'Operations'}>{'Operations'}</Option>);
departmentOptions.push(<Option key={'Compliance'}>{'Compliance'}</Option>);
departmentOptions.push(<Option key={'BD'}>{'BD'}</Option>);
departmentOptions.push(<Option key={'Risk'}>{'Risk'}</Option>);
departmentOptions.push(<Option key={'IT'}>{'IT'}</Option>);
departmentOptions.push(<Option key={'Accounting'}>{'Accounting'}</Option>);
departmentOptions.push(<Option key={'Admin'}>{'Admin'}</Option>);
departmentOptions.push(<Option key={'C-level'}>{'C-level'}</Option>);
// categoryOptions.push(<Option key={'C-level'}>{'C-level'}</Option>);
const regulatorOptions = [];
regulatorOptions.push(<Option key={'AMAC'}>{'AMAC'}</Option>);
regulatorOptions.push(<Option key={'MAS'}>{'MAS'}</Option>);
regulatorOptions.push(<Option key={'SFC'}>{'SFC'}</Option>);
regulatorOptions.push(<Option key={'SEBI'}>{'SEBI'}</Option>);
regulatorOptions.push(<Option key={'FSA'}>{'FSA'}</Option>);
const licenseOptions = []; 
licenseOptions.push(<Option key={'Investment Adviser'}>{'Investment Adviser'}</Option>);
licenseOptions.push(<Option key={'ITP'}>{'ITP'}</Option>);
licenseOptions.push(<Option key={'Type 9-LR'}>{'Type 9-LR'}</Option>);
licenseOptions.push(<Option key={'Type 9-RO'}>{'Type 9-RO'}</Option>);
licenseOptions.push(<Option key={'证券类投资基金从业资格'}>{'证券类投资基金从业资格'}</Option>);
licenseOptions.push(<Option key={'LFMC-LR'}>{'LFMC-LR'}</Option>);
licenseOptions.push(<Option key={'MIC'}>{'MIC'}</Option>);
licenseOptions.push(<Option key={'NIL'}>{'NIL'}</Option>);



const applicationStatusOptions = [];
applicationStatusOptions.push(<Option key={'Accepted'}>{'Accepted'}</Option>);
applicationStatusOptions.push(<Option key={'Outstanding'}>{'Outstanding'}</Option>);
applicationStatusOptions.push(<Option key={'N/A'}>{'N/A'}</Option>);

const licensingStatusOptions = [];
licensingStatusOptions.push(<Option key={'Cpted'}>{'Cpted'}</Option>);
licensingStatusOptions.push(<Option key={'Uncpted'}>{'Uncpted'}</Option>);
licensingStatusOptions.push(<Option key={'N/A'}>{'N/A'}</Option>);
licensingStatusOptions.push(<Option key={'Decpted'}>{'Decpted'}</Option>);

const examinationStatusOptions = [];
examinationStatusOptions.push(<Option key={'Passed'}>{'Passed'}</Option>);
examinationStatusOptions.push(<Option key={'To be completed'}>{'To be completed'}</Option>);
examinationStatusOptions.push(<Option key={'N/A'}>{'N/A'}</Option>);



const officeOptions = [];
officeOptions.push(<Option key={'SH'}>{'SH'}</Option>);
officeOptions.push(<Option key={'HK'}>{'HK'}</Option>);
officeOptions.push(<Option key={'SG'}>{'SG'}</Option>);
officeOptions.push(<Option key={'IN'}>{'IN'}</Option>);
officeOptions.push(<Option key={'JP'}>{'JP'}</Option>);
officeOptions.push(<Option key={'HN'}>{'HN'}</Option>);
// fundCoOptions.push(<Option key={'PIAS (India)'}>{'PIAS (India)'}</Option>);
// fundCoOptions.push(<Option key={'PCMG'}>{'PCMG'}</Option>);
// fundCoOptions.push(<Option key={'COP GP'}>{'COP GP'}</Option>);
// fundCoOptions.push(<Option key={'COP'}>{'COP'}</Option>);
// fundCoOptions.push(<Option key={'PAMF VCC'}>{'PAMF VCC'}</Option>);
// fundCoOptions.push(<Option key={'PMSF'}>{'PMSF'}</Option>);
// fundCoOptions.push(<Option key={'PCF'}>{'PCF'}</Option>);
// fundCoOptions.push(<Option key={'CVF'}>{'CVF'}</Option>);
// fundCoOptions.push(<Option key={'SLHL'}>{'SLHL'}</Option>);
// fundCoOptions.push(<Option key={'ZJNF'}>{'ZJNF'}</Option>);
// fundCoOptions.push(<Option key={'COP'}>{'COP'}</Option>);
// fundCoOptions.push(<Option key={'DCL'}>{'DCL'}</Option>);
// fundCoOptions.push(<Option key={'Others'}>{'Others'}</Option>);

const statusOptions = [];
statusOptions.push(<Option key={'Accepted'}>{'Accepted'}</Option>);
statusOptions.push(<Option key={'Outstanding'}>{'Outstanding'}</Option>);
statusOptions.push(<Option key={'Terminated'}>{'Terminated'}</Option>);
statusOptions.push(<Option key={'N/A'}>{'N/A'}</Option>);


const importanceOptions = [];
importanceOptions.push(<Option key={'Low'}>{'Low'}</Option>);
importanceOptions.push(<Option key={'Normal'}>{'Normal'}</Option>);
importanceOptions.push(<Option key={'High'}>{'High'}</Option>);




const locationOptions = [];
locationOptions.push(<Option key={'All'}>{'All'}</Option>);
locationOptions.push(<Option key={'Cayman'}>{'Cayman'}</Option>);
locationOptions.push(<Option key={'Hong Kong'}>{'Hong Kong'}</Option>);
locationOptions.push(<Option key={'India'}>{'India'}</Option>);
locationOptions.push(<Option key={'Japan'}>{'Japan'}</Option>);
locationOptions.push(<Option key={'Shanghai'}>{'Shanghai'}</Option>);
locationOptions.push(<Option key={'Singapore'}>{'Singapore'}</Option>);
locationOptions.push(<Option key={'USA'}>{'USA'}</Option>);

const fundCompanyOptions = [];
fundCompanyOptions.push(<Option key={'All'}>{'All'}</Option>);
fundCompanyOptions.push(<Option key={'PAJP'}>{'PAJP'}</Option>);
fundCompanyOptions.push(<Option key={'PAML'}>{'PAML'}</Option>);
fundCompanyOptions.push(<Option key={'PASG'}>{'PASG'}</Option>);
fundCompanyOptions.push(<Option key={'PIAS'}>{'PIAS'}</Option>);
fundCompanyOptions.push(<Option key={'投资顾问'}>{'投资顾问'}</Option>);
fundCompanyOptions.push(<Option key={'投资管理'}>{'投资管理'}</Option>);
fundCompanyOptions.push(<Option key={'资产管理'}>{'资产管理'}</Option>);
fundCompanyOptions.push(<Option key={'CVF'}>{'CVF'}</Option>);
fundCompanyOptions.push(<Option key={'DCL'}>{'DCL'}</Option>);
fundCompanyOptions.push(<Option key={'SLHL'}>{'SLHL'}</Option>);
fundCompanyOptions.push(<Option key={'ZJNF'}>{'ZJNF'}</Option>);
fundCompanyOptions.push(<Option key={'PCF'}>{'PCF'}</Option>);
fundCompanyOptions.push(<Option key={'PLUS'}>{'PLUS'}</Option>);
fundCompanyOptions.push(<Option key={'PMSF'}>{'PMSF'}</Option>);

const frequencyOptions = [];
frequencyOptions.push(<Option key={'EveryWorkday'}>{'EveryWorkday'}</Option>);
frequencyOptions.push(<Option key={'Weekly'}>{'Weekly'}</Option>);
frequencyOptions.push(<Option key={'Monthly'}>{'Monthly'}</Option>);
frequencyOptions.push(<Option key={'Quarterly'}>{'Quarterly'}</Option>);
frequencyOptions.push(<Option key={'SemiAnnually'}>{'SemiAnnually'}</Option>);
frequencyOptions.push(<Option key={'Annually'}>{'Annually'}</Option>);
frequencyOptions.push(<Option key={'Every3Years'}>{'Every3Years'}</Option>);
frequencyOptions.push(<Option key={'Incidental'}>{'Incidental'}</Option>);

const weekdayOptions = [];
weekdayOptions.push(<Option key={'Sun'}>{'Sun'}</Option>);
weekdayOptions.push(<Option key={'Mon'}>{'Mon'}</Option>);
weekdayOptions.push(<Option key={'Tue'}>{'Tue'}</Option>);
weekdayOptions.push(<Option key={'Wed'}>{'Wed'}</Option>);
weekdayOptions.push(<Option key={'Thu'}>{'Thu'}</Option>);
weekdayOptions.push(<Option key={'Fri'}>{'Fri'}</Option>);
weekdayOptions.push(<Option key={'Sat'}>{'Sat'}</Option>);

const monthOptions = [];
monthOptions.push(<Option key={'01'}>{'Jan'}</Option>);
monthOptions.push(<Option key={'02'}>{'Feb'}</Option>);
monthOptions.push(<Option key={'03'}>{'Mar'}</Option>);
monthOptions.push(<Option key={'04'}>{'Apr'}</Option>);
monthOptions.push(<Option key={'05'}>{'May'}</Option>);
monthOptions.push(<Option key={'06'}>{'Jun'}</Option>);
monthOptions.push(<Option key={'07'}>{'Jul'}</Option>);
monthOptions.push(<Option key={'08'}>{'Aug'}</Option>);
monthOptions.push(<Option key={'09'}>{'Sep'}</Option>);
monthOptions.push(<Option key={'10'}>{'Oct'}</Option>);
monthOptions.push(<Option key={'11'}>{'Nov'}</Option>);
monthOptions.push(<Option key={'12'}>{'Dec'}</Option>);

const responsibleDeptOptions = [];
responsibleDeptOptions.push(<Option key={'Accounting'}>{'Accounting'}</Option>);
responsibleDeptOptions.push(<Option key={'BD'}>{'BD'}</Option>);
responsibleDeptOptions.push(<Option key={'Compliance'}>{'Compliance'}</Option>);
responsibleDeptOptions.push(<Option key={'CS'}>{'CS'}</Option>);
responsibleDeptOptions.push(<Option key={'Investment'}>{'Investment'}</Option>);
responsibleDeptOptions.push(<Option key={'IT'}>{'IT'}</Option>);
responsibleDeptOptions.push(<Option key={'Marketing'}>{'Marketing'}</Option>);
responsibleDeptOptions.push(<Option key={'Risk'}>{'Risk'}</Option>);
responsibleDeptOptions.push(<Option key={'Settlement'}>{'Settlement'}</Option>);


const initialState = {
    locationOptions: locationOptions,
    fundCompanyOptions: fundCompanyOptions,
    frequencyOptions: frequencyOptions,
    weekdayOptions: weekdayOptions,
    monthOptions: monthOptions,
    responsibleDeptOptions: responsibleDeptOptions,
    // categoryOptions: categoryOptions,
    departmentOptions: departmentOptions,
    officeOptions: officeOptions,
    // fundCoOptions: fundCoOptions,
    statusOptions: statusOptions,
    importanceOptions: importanceOptions,
    regulatorOptions: regulatorOptions,
    licenseOptions: licenseOptions,
    applicationStatusOptions: applicationStatusOptions,
    licensingStatusOptions: licensingStatusOptions,
    examinationStatusOptions: examinationStatusOptions,
    cptQueryFields: {
        id: undefined,
        name: undefined,
        status: undefined,
    
    },

    selectedCptArray: [],
    selectedCptTaskArray: [],
    registerInfoList: [],
    addOrEditCptModal: {
        isOpened: false,
        mode: 'ADD',
        respErrMsg: '',
        fields: {
            id: undefined,
            name: undefined,
            regulator: undefined,
            license: undefined,
            licenseNo: undefined,
            applicationStatus: undefined,
            licensingStatus: undefined,
            licensedDate: undefined,
            validTo: undefined,
            year: undefined,
            cptRequirement: undefined,
            examinationStatus: undefined,
            examinationDeadline: undefined,
            deregistrationDate: undefined,
            sendmail: undefined,
            remarks: undefined,
            comments: undefined,

        },
    },
    addOrEditCptSubModal: {
        isOpened: false,
        mode: 'ADD',
        respErrMsg: '',
        fields: {
            id: undefined,
            workid: undefined,
            details: undefined,
            startdate: undefined,
            targetdate: undefined,
            enddate: undefined,
            personlncharge: undefined,
            status: undefined,
            sendmail: undefined,
            // status: undefined,
            // importance: undefined,
            // remarks: undefined,
            // comments: undefined,

        },
    },
    batchChangeStatusModal: {
        isOpened: false,
        mode: 'PAUSE',
        respErrMsg: '',
        fields: {
            idList: [],
            comments: undefined,
        },
    },

    finishTaskModal: {
        isOpened: false,
        respErrMsg: '',
        fields: {
            id: undefined,
            remarks: undefined,
            comments: undefined,
        },
    },

    userAccountEmailOptions: [],
    // Open/Reset Questionnaire Email Edit Modal Dialog
    questionnaireEmailEditControlModal: {
        isOpened: false,
        sendMode: QUESTIONNAIRE_EMAIL_SEND_MODE.NONE,
        emailPayload: null,
        respErrMsg: '',
    },
    // Accept Questionnaire Result
    acceptQuestionnaireResultActionStatus: ACTION_STATUS.READY,

    // Reject Questionnaire Result
    rejectQuestionnaireResultActionStatus: ACTION_STATUS.READY,
    licensingFormOptions: [],

    };



// query
function onReportSummaryQueryInputChange(state, {name, value}) {
    const upatedFields = {
        ...state.cptQueryFields,
        [name]: value,
    };
    return {
        ...state,
        cptQueryFields: upatedFields,
    }
}
function startLoadCptInfo(state) {
    return {
        ...state,
        loadCptInfoActionStatus: ACTION_STATUS.LOGINING,
      };
}
function loadCptInfoSuccess(state, resp) {
    return {
        ...state,
        loadCptInfoActionStatus: ACTION_STATUS.SUCCESS,
        loadCptInfoResp: resp,
    };
}
function loadCptInfoFailure(state, err) {
    return {
        ...state,
        loadCptInfoActionStatus: ACTION_STATUS.ERROR,
        loadCptInfoResp: err,
    };
}
function initLoadCptInfoActionStatus(state) {
    return {
        ...state,
        loadCptInfoActionStatus: ACTION_STATUS.READY,
        selectedCptArray: [],
        selectedCptTaskArray: [],
    };
}


// select
function selectCpt(state, array) {
    return {
        ...state,
        selectedCptArray: array,
    };
}


// add or edit
function openAddOrEditCptModal(state, {mode, data}) {
    if(mode === 'ADD') {
        return {
            ...state,
            addOrEditCptModal: {
                ...state.addOrEditCptModal,
                isOpened: true,
                mode,
            },
        };

    } else {

        const {
            id,
            name,
            regulator,
            license,
            licenseNo,
            applicationStatus,
            licensingStatus,
            licensedDate,
            validTo,
            year,
            cptRequirement,
            examinationStatus,
            examinationDeadline,
            deregistrationDate,
            remarks,
            comments,
            sendmail,
        } = data;



        return {
            ...state,
            addOrEditCptModal: {
                ...state.addOrEditCptModal,
                isOpened: true,
                mode,
                fields: {
                    ...state.addOrEditCptModal.fields,
                
                    id: data.id,
                    formGuid:  data.formGuid,
                    name:  data.name,
                    regulator:  data.regulator,
                    license:  data.license,
                    licenseNo:  data.licenseNo,
                    applicationStatus:  data.applicationStatus,
                    licensingStatus:  data.licensingStatus,
                    licensedDate:  data.licensedDate,
                    validTo:  data.validTo,
                    year:  data.year,
                    cptRequirement:  data.cptRequirement,
                    examinationStatus:  data.examinationStatus,
                    examinationDeadline:  data.examinationDeadline,
                    deregistrationDate:  data.deregistrationDate,
                    remarks: data.remarks,
                    comments: data.comments,
                    sendmail: data.sendmail,
                
                }
            },
        }

    }
}
function addOrEditCptChangeInput(state, {name, value}) {
    const updatedFields = {
        ...state.addOrEditCptModal.fields,
        [name]: value,
    };
    return {
        ...state,
        addOrEditCptModal: {
          ...state.addOrEditCptModal,
          fields: updatedFields,
        },
    };
}
function resetSubmitSaveCptModal(state) {
    return {
        ...state,
        addOrEditCptModal: initialState.addOrEditCptModal,
    }
}

function startSubmitSaveCpt(state) {
    return {
        ...state,
        addOrEditCptStatus: ACTION_STATUS.LOGINING,
    };
}
function submitSaveCptSuccess(state, resp) {
    return {
        ...state,
        addOrEditCptStatus: ACTION_STATUS.SUCCESS,
    }; 
}
function submitSaveCptFailure(state, err) {
    return {
        ...state,
        addOrEditCptStatus: ACTION_STATUS.ERROR,
        addOrEditCptModal: {
            ...state.addOrEditCptModal,
            respErrMsg: err.respMessage,
        }
    };
}
function initSubmitSaveCptActionStatus(state) {
    return {
        ...state,
        addOrEditCptStatus: ACTION_STATUS.READY,
    };
}



//sub、 add or edit
function openAddOrEditCptSubModal(state, {mode, data,idList}) {
    if(mode === 'ADD') {
        return {
            ...state,
            addOrEditCptSubModal: {
                ...state.addOrEditCptSubModal,
                isOpened: true,
                mode,
                idList,
            },
        };

    } else {

        const {
            id,
            workid,
            details,
            startdate,
            targetdate,
            enddate,
            personlncharge,
            status,
        } = data;



        return {
            ...state,
            addOrEditCptSubModal: {
                ...state.addOrEditCptSubModal,
                isOpened: true,
                mode,
                fields: {
                    ...state.addOrEditCptSubModal.fields,
                    id,
                    workid,
                    details,
                    startdate,
                    targetdate,
                    enddate,
                    personlncharge,
                    status,
                
                }
            },
        }

    }
}
function addOrEditCptSubChangeInput(state, {name, value}) {
    const updatedFields = {
        ...state.addOrEditCptSubModal.fields,
        [name]: value,
    };
    return {
        ...state,
        addOrEditCptSubModal: {
          ...state.addOrEditCptSubModal,
          fields: updatedFields,
        },
    };
}
function resetSubmitSaveCptSubModal(state) {
    return {
        ...state,
        addOrEditCptSubModal: initialState.addOrEditCptSubModal,
    }
}

function startSubmitSaveCptSub(state) {
    return {
        ...state,
        addOrEditCptSubStatus: ACTION_STATUS.LOGINING,
    };
}
function submitSaveCptSubSuccess(state, resp) {
    return {
        ...state,
        addOrEditCptSubStatus: ACTION_STATUS.SUCCESS,
    }; 
}
function submitSaveCptSubFailure(state, err) {
    return {
        ...state,
        addOrEditCptSubStatus: ACTION_STATUS.ERROR,
        addOrEditCptSubModal: {
            ...state.addOrEditCptSubModal,
            respErrMsg: err.respMessage,
        }
    };
}
function initSubmitSaveCptSubActionStatus(state) {
    return {
        ...state,
        addOrEditCptSubStatus: ACTION_STATUS.READY,
    };
}





















// batch change status
function openBatchChangeStatusModal(state, {mode, idList}) {
    return {
        ...state,
        batchChangeStatusModal: {
            ...state.batchChangeStatusModal,
            isOpened: true,
            mode,
            fields: {
                ...state.batchChangeStatusModal.fields,
                idList,
            },
        },
    };
}
function resetBatchChangeStatusModal(state) {
    return {
        ...state,
        batchChangeStatusModal: initialState.batchChangeStatusModal,
    }
}
function batchChangeStatusChangeInput(state, {name, value}) {
    const updatedFields = {
        ...state.batchChangeStatusModal.fields,
        [name]: value,
    };
    return {
        ...state,
        batchChangeStatusModal: {
          ...state.batchChangeStatusModal,
          fields: updatedFields,
        },
    };
}

function startBatchChangeStatusForCpt(state) {
    return {
        ...state,
        batchChangeStatusForCptStatus: ACTION_STATUS.LOGINING,
    };
}
function batchChangeStatusForCptSuccess(state, resp) {
    return {
        ...state,
        batchChangeStatusForCptStatus: ACTION_STATUS.SUCCESS,
    }; 
}
function batchChangeStatusForCptFailure(state, err) {
    return {
        ...state,
        batchChangeStatusForCptStatus: ACTION_STATUS.ERROR,
        batchChangeStatusModal: {
            ...state.batchChangeStatusModal,
            respErrMsg: err.respMessage,
        }
    };
}
function initBatchChangeStatusForCptActionStatus(state) {
    return {
        ...state,
        batchChangeStatusForCptStatus: ACTION_STATUS.READY,
    };
}


// finish
function selectCptTask(state, array) {
    return {
        ...state,
        selectedCptTaskArray: array,
    };
}
function openFinishTaskModal(state, task) {
    return {
        ...state,
        finishTaskModal: {
            ...state.finishTaskModal,
            isOpened: true,
            fields: {
                ...state.finishTaskModal.fields,
                id: task.id,
                remarks: task.remarks,
            },
        },
    };
}
function resetFinishTaskModal(state) {
    return {
        ...state,
        finishTaskModal: initialState.finishTaskModal,
    }; 
}
function finishTaskChangeInput(state, {name, value}) {
    const updatedFields = {
        ...state.finishTaskModal.fields,
        [name]: value,
    };
    return {
        ...state,
        finishTaskModal: {
          ...state.finishTaskModal,
          fields: updatedFields,
        },
    };
}

function startFinishCptTask(state) {
    return {
        ...state,
        finishCptTaskStatus: ACTION_STATUS.LOGINING,
    };
}
function finishCptTaskSuccess(state, resp) {
    return {
        ...state,
        finishCptTaskStatus: ACTION_STATUS.SUCCESS,
    }; 
}
function finishCptTaskFailure(state, err) {
    return {
        ...state,
        finishCptTaskStatus: ACTION_STATUS.ERROR,
        finishTaskModal: {
            ...state.finishTaskModal,
            respErrMsg: err.respMessage,
        }
    };
}
function initFinishCptTaskActionStatus(state) {
    return {
        ...state,
        finishCptTaskStatus: ACTION_STATUS.READY,
    };
}


// user account
function loadUserAccountsSuccess(state, resp) {
      const userAccountArray = resp.data;
      const userAccountOptions = userAccountArray.map(userAccount => <Option key={userAccount.englishName}>{userAccount.englishName}</Option>);
    
      return {
        ...state,
        userAccountArray,
        userAccountOptions,
      };
}

// Open/Reset Questionnaire Email Edit Modal Dialog
function openQuestionnaireEmailEditModalDialog(state, {sendMode, emailPayload}) {
    return {
      ...state,
      questionnaireEmailEditControlModal: {
        ...state.questionnaireEmailEditControlModal,
        isOpened: true,
        sendMode,
        emailPayload,
      },
    };
  }
  
  function resetQuestionnaireEmailEditModalDialog(state) {
    return {
      ...state,
      questionnaireEmailEditControlModal: initialState.questionnaireEmailEditControlModal,
    };
  }

// Accept Questionnaire Result
function startAcceptQuestionnaireResult(state) {
    return {
      ...state,
      acceptQuestionnaireResultActionStatus: ACTION_STATUS.LOGINING,
    };
  }
  
  function acceptQuestionnaireResultSuccess(state, resp) {
    return {
      ...state,
      acceptQuestionnaireResultActionStatus: ACTION_STATUS.SUCCESS,
    };
  }
  
  function acceptQuestionnaireResultFailure(state, err) {
    return {
      ...state,
      acceptQuestionnaireResultActionStatus: ACTION_STATUS.ERROR,
      questionnaireEmailEditControlModal: {
        ...state.questionnaireEmailEditControlModal,
        respErrMsg: err.respMessage,
      },
    };
  }
  
  function initAcceptQuestionnaireResultActionStatus(state) {
    return {
      ...state,
      acceptQuestionnaireResultActionStatus: ACTION_STATUS.READY,
    };
  }
  
  // Reject Questionnaire Result
  function startRejectQuestionnaireResult(state) {
    return {
      ...state,
      rejectQuestionnaireResultActionStatus: ACTION_STATUS.LOGINING,
    };
  }
  
  function rejectQuestionnaireResultSuccess(state, resp) {
    return {
      ...state,
      rejectQuestionnaireResultActionStatus: ACTION_STATUS.SUCCESS,
    };
  }
  
  function rejectQuestionnaireResultFailure(state, err) {
    return {
      ...state,
      rejectQuestionnaireResultActionStatus: ACTION_STATUS.ERROR,
      questionnaireEmailEditControlModal: {
        ...state.questionnaireEmailEditControlModal,
        respErrMsg: err.respMessage,
      },
    };
  }
  
  function initRejectQuestionnaireResultActionStatus(state) {
    return {
      ...state,
      rejectQuestionnaireResultActionStatus: ACTION_STATUS.READY,
    };
  }

  function loadLicensingFormSuccess(state, resp) {
    const licensingFormArray = resp.data;
    const licensingFormOptions = licensingFormArray.map(licensingForm => <Option key={licensingForm.guid}>{licensingForm.name}</Option>);
  
    return {
      ...state,
    //   loadLicensingFormActionStatus: ACTION_STATUS.SUCCESS,
    //   licensingFormArray,
      licensingFormOptions,
    };
  }

// Send Remind Email
function startSendRemindEmail(state) {
    return {
      ...state,
      sendRemindEmailActionStatus: ACTION_STATUS.LOGINING,
    };
  }
  
  function sendRemindEmailSuccess(state, resp) {
    return {
      ...state,
      sendRemindEmailActionStatus: ACTION_STATUS.SUCCESS,
    };
  }
  
  function sendRemindEmailFailure(state, err) {
    return {
      ...state,
      sendRemindEmailActionStatus: ACTION_STATUS.ERROR,
      questionnaireEmailEditControlModal: {
        ...state.questionnaireEmailEditControlModal,
        respErrMsg: err.respMessage,
      },
    };
  }
  
  function initSendRemindEmailActionStatus(state) {
    return {
      ...state,
      sendRemindEmailActionStatus: ACTION_STATUS.READY,
    };
  }
  function setRegisterInfoByName(state, registerInfoList) {
    return {
        ...state,
        registerInfoList: registerInfoList,
    }
}

export default createReducer(initialState, {
    // query
    [ON_WORK_MANAGEMENT_QUERY_INPUT_CHANGE]: onReportSummaryQueryInputChange,
    [START_LOAD_CPT_INFO]: startLoadCptInfo,
    [LOAD_CPT_INFO_SUCCESS]: loadCptInfoSuccess,
    [LOAD_CPT_INFO_FAILURE]: loadCptInfoFailure,
    [INIT_LOAD_CPT_INFO_ACTION_STATUS]: initLoadCptInfoActionStatus,
    // select
    [SELECT_CPT]: selectCpt,
    // add or edit
    [OPEN_ADD_OR_EDIT_CPT_MODAL]: openAddOrEditCptModal,
    [ADD_OR_EDIT_CPT_CHANGE_INPUT]: addOrEditCptChangeInput,
    [RESET_SUBMIT_SAVE_CPT_MODAL]: resetSubmitSaveCptModal,
    [START_SUBMIT_SAVE_CPT]: startSubmitSaveCpt,
    [SUBMIT_SAVE_CPT_SUCCESS]: submitSaveCptSuccess,
    [SUBMIT_SAVE_CPT_FAILURE]: submitSaveCptFailure,
    [INIT_SUBMIT_SAVE_CPT_ACTION_STATUS]: initSubmitSaveCptActionStatus,


    //SUB add or edit
    [OPEN_ADD_OR_EDIT_CPTSUB_MODAL]: openAddOrEditCptSubModal,
    [ADD_OR_EDIT_CPTSUB_CHANGE_INPUT]: addOrEditCptSubChangeInput,
    [RESET_SUBMIT_SAVE_CPTSUB_MODAL]: resetSubmitSaveCptSubModal,
    [START_SUBMIT_SAVE_CPTSUB]: startSubmitSaveCptSub,
    [SUBMIT_SAVE_CPTSUB_SUCCESS]: submitSaveCptSubSuccess,
    [SUBMIT_SAVE_CPTSUB_FAILURE]: submitSaveCptSubFailure,
    [INIT_SUBMIT_SAVE_CPTSUB_ACTION_STATUS]: initSubmitSaveCptSubActionStatus,





    // batch change status
    [OPEN_BATCH_CHANGE_STATUS_MODAL]: openBatchChangeStatusModal,
    [RESET_BATCH_CHANGE_STATUS_MODAL]: resetBatchChangeStatusModal,
    [BATCH_CHANGE_STATUS_CHANGE_INPUT]: batchChangeStatusChangeInput,
    [START_BATCH_CHANGE_STATUS_FOR_CPT]: startBatchChangeStatusForCpt,
    [BATCH_CHANGE_STATUS_FOR_CPT_SUCCESS]: batchChangeStatusForCptSuccess,
    [BATCH_CHANGE_STATUS_FOR_CPT_FAILURE]: batchChangeStatusForCptFailure,
    [INIT_BATCH_CHANGE_STATUS_FOR_CPT_ACTION_STATUS]: initBatchChangeStatusForCptActionStatus,
    // finish
    [SELECT_CPT_TASK]: selectCptTask,
    [OPEN_FINISH_TASK_MODAL]: openFinishTaskModal,
    [RESET_FINISH_TASK_MODAL]: resetFinishTaskModal,
    [FINISH_TASK_CHANGE_INPUT]: finishTaskChangeInput,
    [START_FINISH_CPT_TASK]: startFinishCptTask,
    [FINISH_CPT_TASK_SUCCESS]: finishCptTaskSuccess,
    [FINISH_CPT_TASK_FAILURE]: finishCptTaskFailure,
    [INIT_FINISH_CPT_TASK_ACTION_STATUS]: initFinishCptTaskActionStatus,
    // user account
    [LOAD_USER_ACCOUNTS_SUCCESS]: loadUserAccountsSuccess,

        // Load User Account
        [LOAD_USER_ACCOUNTS_SUCCESS]: loadUserAccountsSuccess,

      // Open/Reset Questionnaire Email Edit Modal Dialog
    [QUESTIONNAIRE_EMAIL_EDIT_MODAL_DIALOG_OPEN]: openQuestionnaireEmailEditModalDialog,
    [QUESTIONNAIRE_EMAIL_EDIT_MODAL_DIALOG_RESET]: resetQuestionnaireEmailEditModalDialog,
    [LOAD_LICENSINGFORM_SUCCESS]: loadLicensingFormSuccess,


    // Accept Questionnaire Result
  [START_ACCEPT_QUESTIONNAIRE_RESULT]: startAcceptQuestionnaireResult,
  [ACCEPT_QUESTIONNAIRE_RESULT_SUCCESS]: acceptQuestionnaireResultSuccess,
  [ACCEPT_QUESTIONNAIRE_RESULT_FAILURE]: acceptQuestionnaireResultFailure,
  [INIT_ACCEPT_QUESTIONNAIRE_RESULT_ACTION_STATUS]: initAcceptQuestionnaireResultActionStatus,

  // Reject Questionnaire Result
  [START_REJECT_QUESTIONNAIRE_RESULT]: startRejectQuestionnaireResult,
  [REJECT_QUESTIONNAIRE_RESULT_SUCCESS]: rejectQuestionnaireResultSuccess,
  [REJECT_QUESTIONNAIRE_RESULT_FAILURE]: rejectQuestionnaireResultFailure,
  [INIT_REJECT_QUESTIONNAIRE_RESULT_ACTION_STATUS]: initRejectQuestionnaireResultActionStatus,
  // Send Remind Email
  [START_SEND_REMIND_EMAIL]: startSendRemindEmail,
  [SEND_REMIND_EMAIL_SUCCESS]: sendRemindEmailSuccess,
  [SEND_REMIND_EMAIL_FAILURE]: sendRemindEmailFailure,
  [INIT_SEND_REMIND_EMAIL_ACTION_STATUS]: initSendRemindEmailActionStatus,

  [SET_REGISTER_INFO_BY_NAME]: setRegisterInfoByName,
});

